import styled, { css } from 'styled-components';

export const Wrapper = styled.section`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;
export const WrapperPlan = styled.section`
  ${() => css`
    margin-bottom: 2.4rem;
    background-color: white;
    border-radius: 12px;
    padding: 24px;
  `}
`;

export const WrapperTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0.6rem 0 2.4rem;
  line-height: 5rem;
`;

export const WrapperText = styled.p`
  ${() => css`
    color: red;
    font-size: 2rem;
  `}
`;

export const WrapperButton = styled.button`
  ${() => css`
    color: #298ee6;
    font-size: 2rem;
  `}
`;

export const WrapperBanners = styled.div`
  ${() => css`
    margin-bottom: 2.4rem;
  `}
`;

export const ElementWrapper = styled.div`
  ${() => css`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    > div + div {
      margin-top: 1.6rem;
    }
  `}
`;
export const StatusContainer = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    gap: 16px;
  `}
`;
export const Status = styled.div<{ backgroundColor: string }>`
  ${({ backgroundColor }) => css`
    display: flex;
    align-items: center;
    border-radius: 16px;
    padding: 8px 16px;
    margin-bottom: 16px;
    margin-top: 16px;
    cursor: pointer;
    gap: 8px;
    background-color: ${backgroundColor};
    span {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  `}
`;
export const LastInvoiceWrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 2.7rem;

    a {
      text-decoration: none;
    }
  `}
`;

export const contentMyProducts = styled.div`
  ${() => css`
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 2rem;
    row-gap: 2rem;
    margin-top: 16px;
    @media (min-width: 800px) and (max-width: 1023px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    }
  `}
`;
export const Title = styled.div`
  display: flex;
  gap: 9px;
  align-items: center;
`;
export const ShowButton = styled.span`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #298ee6;
  cursor: pointer;
`;
export const ScrollableWrapper = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  white-space: nowrap;
  margin-top: 16px;
  width: 100%;
  padding-bottom: 10px;
  ::-webkit-scrollbar {
    width: 0.5rem;
    height: 8px;
    border-radius: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
    border-radius: 8px;
  }
`;
